(function () {
  // Guards against this file being loaded twice on one page (e.g. the
  // sitewide campaign bar and the campaign-hero section both link it).
  if (window.__campaignCountdownLoaded) return;
  window.__campaignCountdownLoaded = true;

  // Resolves a wall-clock time in Europe/Amsterdam (e.g. a plain "YYYY-MM-DD"
  // date at end-of-day) to the correct UTC instant, DST-aware — so every
  // visitor counts down to the same real moment regardless of their own
  // local timezone. One correction pass is enough since the Amsterdam
  // UTC offset never changes within a single day.
  function amsterdamOffsetMillis(utcDate) {
    var dtf = new Intl.DateTimeFormat('en-US', {
      timeZone: 'Europe/Amsterdam',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false
    });
    var parts = {};
    dtf.formatToParts(utcDate).forEach(function (p) {
      parts[p.type] = p.value;
    });
    var hour = parts.hour === '24' ? 0 : parseInt(parts.hour, 10);
    var asUtc = Date.UTC(
      parseInt(parts.year, 10),
      parseInt(parts.month, 10) - 1,
      parseInt(parts.day, 10),
      hour,
      parseInt(parts.minute, 10),
      parseInt(parts.second, 10)
    );
    return asUtc - utcDate.getTime();
  }

  function amsterdamLocalToUtc(y, m, d, h, min, s) {
    var guess = Date.UTC(y, m - 1, d, h, min, s);
    var offset = amsterdamOffsetMillis(new Date(guess));
    return guess - offset;
  }

  // Accepts either a bare date ("2026-10-04", treated as 23:59:59 that day
  // in Europe/Amsterdam) or a full ISO datetime string.
  function parseCountdownTarget(targetStr) {
    var dateOnly = /^(\d{4})-(\d{2})-(\d{2})$/.exec(targetStr);
    if (dateOnly) {
      return amsterdamLocalToUtc(
        parseInt(dateOnly[1], 10),
        parseInt(dateOnly[2], 10),
        parseInt(dateOnly[3], 10),
        23,
        59,
        59
      );
    }
    return new Date(targetStr).getTime();
  }

  document.addEventListener('DOMContentLoaded', function () {
    var elements = document.querySelectorAll('[data-campaign-countdown]');

    elements.forEach(function (el) {
      var targetStr = el.getAttribute('data-countdown-target');
      if (!targetStr) return;
      var target = parseCountdownTarget(targetStr);
      var expiredText = el.getAttribute('data-countdown-expired-text');

      var daysEl = el.querySelector('[data-cd-days]');
      var hoursEl = el.querySelector('[data-cd-hours]');
      var minEl = el.querySelector('[data-cd-min]');
      var secEl = el.querySelector('[data-cd-sec]');
      var liveEl = el.querySelector('[data-cd-live]');
      var expiredEl = el.querySelector('[data-cd-expired]');

      function pad(n) {
        return ('0' + n).slice(-2);
      }

      function showExpired() {
        if (expiredEl || liveEl) {
          if (liveEl) liveEl.hidden = true;
          if (expiredEl) expiredEl.hidden = false;
        } else if (expiredText) {
          el.textContent = expiredText;
        } else {
          el.hidden = true;
        }
      }

      function update() {
        var now = new Date().getTime();
        var diff = target - now;
        if (diff <= 0) {
          showExpired();
          return true;
        }
        var days = Math.floor(diff / (1000 * 60 * 60 * 24));
        var hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        var mins = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
        var secs = Math.floor((diff % (1000 * 60)) / 1000);
        if (daysEl) daysEl.textContent = days;
        if (hoursEl) hoursEl.textContent = pad(hours);
        if (minEl) minEl.textContent = pad(mins);
        if (secEl) secEl.textContent = pad(secs);
        return false;
      }

      var expired = update();
      if (!expired) {
        var timer = setInterval(function () {
          if (update()) clearInterval(timer);
        }, 1000);
      }
    });
  });

  document.addEventListener('DOMContentLoaded', function () {
    var links = document.querySelectorAll('[data-hero-scroll]');
    links.forEach(function (link) {
      link.addEventListener('click', function (event) {
        var href = link.getAttribute('href');
        if (!href || href.charAt(0) !== '#') return;
        var target = document.querySelector(href);
        if (!target) return;
        event.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  });
})();
